import { Component, OnInit } from '@angular/core';
import { ICellRendererAngularComp } from '@ag-grid-community/angular';
import { ICellRendererParams, IAfterGuiAttachedParams } from "@ag-grid-enterprise/all-modules";
import { ManageAttributesComponent } from '../manage-attributes.component';

@Component({
  selector: 'app-delete-cell-render',
  template: `<button type="button" class="btn btn-sm btn-outline-dark py-0 my-1 px-1 border-0"
				(click)="onDeleteButtonClick()">
				<i class="far fa-trash-alt" aria-hidden="true"></i>
			</button>`,
  styles: []
})
export class DeleteCellRenderComponent implements OnInit, ICellRendererAngularComp {
  public attribute: any;
  public componentParent: ManageAttributesComponent;
  private cellData;

  constructor() { }

  ngOnInit() {
  }

  refresh(params: any): boolean {
    return true;
  }

  agInit(params: ICellRendererParams): void {
    this.cellData = params.data;
    this.componentParent = params.context.componentParent;
    if (params.data != undefined) {
      this.attribute = params.data;
    } else {
      this.attribute = params.value;
    }
  }

  afterGuiAttached?(params?: IAfterGuiAttachedParams): void {
  }

  onDeleteButtonClick() {
    this.componentParent.deleteTagAttribute(this.cellData);
  }
}
